import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom'
import {AuthProvider} from './context/auth.js'
import 'antd/dist/reset.css';
import { SearchProvider } from './context/search.js';
import { CardProvider } from './context/card.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <SearchProvider>
      <CardProvider>
      <BrowserRouter>  
        <App />
      

      </BrowserRouter>
      </CardProvider>
   </SearchProvider>
  </AuthProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
